module.exports = __webpack_public_path__ + "static/media/transparent.721bc690.jpg";